module.exports = __webpack_public_path__ + "img/can8.555d6f73.png";